exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody > tr > td[data-v-f4ea4626] {\n  padding: 0.5rem;\n}", ""]);

// exports
